import { useSelector } from 'react-redux';
export const selectUserEmulation = (state) => state.userEmulation;
export const useSelectUserEmulation = () => useSelector(selectUserEmulation);
